export enum UserTokenStatusEnum {
  Unblocked = 'unblocked',
  Suspended = 'suspended',
  ExpiredDueToTakeSessionByTheSameUser = 'expiredDueToTakeSessionByTheSameUser',
  ExpiredDueToTakeSessionByAnotherCompanyUser = 'expiredDueToTakeSessionByAnotherCompanyUser',
  ExpiredAfterLogout = 'expiredAfterLogout',
}
